<div *ngIf="isloader" class="h-100 padt-5">
  <mat-progress-bar [mode]="'indeterminate'">
  </mat-progress-bar>
</div>
<div *ngIf="!isloader">
    <app-common-table [tableData]="dtcPredictionData" 
        [columnHeader]="dtcPredictionsHeaders"  pageType="dtcPredictions" class="app-common-table" 
        [actionPermission]="{pagination: true}" (tableAction)="tableAction($event)">
  </app-common-table>
</div>